// adding some validations logic for home insurance form
import { required, email, minLength, numeric, between } from 'vuelidate/lib/validators'

export const FORM_HOME_VALIDATIONS = {
  userDataForm: {
    title: {
      required
    },
    firstname: {
      required,
      minLength: minLength(3)
    },
    middlename: {
      minLength: minLength(3)
    },
    lastname: {
      required,
      minLength: minLength(3)
    },
    maritalstatus: {
      required
    },
    phonenumber: {
      required,
      numeric,
      minLength: minLength(10)
    },
    email: {
      required,
      email
    },
    country: {
      required,
      minLength: minLength(3)
    },
    datebirth: {
      required,
      minLength: minLength(3)
    },
    occupation: {
      required,
      minLength: minLength(5)
    },
    address: {
      required,
      minLength: minLength(15)
    },
    typehome: {
      required
    },
    buildingage: {
      required,
      numeric,
      between: between(1, 25)
    },
    ownershipstatus: {
      required
    },
    insurancestart: {
      required,
      minLength: minLength(3)
    },
    typecover: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/validations/formHome.js